/** Auto answer settings for MyCalls and MyCallsCall */
export interface MyCallsAutoAnswer {
	/** True if we shall auto answer next call */
	enabled: boolean
	/** Timer that expires the auto answer after 5 seconds */
	timer?: ReturnType<typeof setTimeout>
	/** Session id for the call to answer */
	sessionId?: string
	/** The last time a call was auto-answered */
	last?: Date
}

export enum MyCallsPhoneType {
	SOFTPHONE = 'SOFTPHONE',
	SIPPHONE = 'SIPPHONE',
	MOBILE = 'MOBILE',
	EXTERNAL = 'EXTERNAL',
	NONE = 'NONE'
}
